import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { volumes, bonuses } from '../data/content';
import { PRICE } from '../config/site';
import { CTAButton } from './CTAButton';
import { DailyCountdown } from './DailyCountdown';
export function OfferStack() {
  return <section id="oferta" className="w-full scroll-mt-16 bg-white/75 px-5 py-14 sm:py-20" data-id="element-168" data-mp="2kx4wouciryxa">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.15
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto max-w-[620px]" data-id="element-169" data-mp="1x5pqurljazha">
        <h2 className="text-center font-display text-2xl font-bold text-ink sm:text-4xl" data-id="element-170" data-mp="26y54xdtpn3ww">
          Dzisiaj otrzymujesz cały system
        </h2>

        <div className="mt-8 rounded-2xl border border-chem/20 bg-white p-5 shadow-sm shadow-chem/5 sm:p-7" data-id="element-171" data-mp="1eey9p3vb24sc">
          <ul className="space-y-2.5" data-id="element-172" data-mp="19g56q5dn9w6f">
            {volumes.map(volume => <li key={volume.number} className="flex items-start gap-3" data-id="element-173" data-mp="14pv5oztv9773">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-chem/12 text-chem-deep" data-id="element-174" data-mp="19nwsnvuexqnu">
                  <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-175" data-mp="1efy094gmyt7j" />
                </span>
                <span className="text-sm leading-relaxed text-ink/85" data-id="element-176" data-mp="1jcy73hlb7zzp">
                  <span className="font-semibold text-ink" data-id="element-177" data-mp="lqhakekehqf0">Tom {volume.number}</span> — {volume.title}
                </span>
              </li>)}
            {bonuses.map(bonus => <li key={bonus.badge} className="flex items-start gap-3" data-id="element-178" data-mp="von9cnawugfn">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-chem/12 text-chem-deep" data-id="element-179" data-mp="vqhua1m6m8jq">
                  <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-180" data-mp="2743kzr7owi7d" />
                </span>
                <span className="text-sm leading-relaxed text-ink/85" data-id="element-181" data-mp="2b4vxqufrt58e">
                  <span className="font-semibold text-ink" data-id="element-182" data-mp="2b7091xg016ip">{bonus.badge}</span> — {bonus.title}
                </span>
              </li>)}
          </ul>

          <div className="mt-5 grid grid-cols-2 gap-3 border-t border-dashed border-chem/25 pt-5 text-center" data-id="element-183" data-mp="70j783rb77xb">
            <div className="rounded-xl bg-paper px-3 py-3" data-id="element-184" data-mp="l0k9nnn82new">
              <p className="font-display text-xl font-bold text-chem sm:text-2xl" data-id="element-185" data-mp="g1r3yhe6g0pa">10</p>
              <p className="mt-1 text-[11px] font-semibold uppercase tracking-[0.1em] text-ink/65" data-id="element-186" data-mp="3ohatp6fn30zl">
                Elementów edukacyjnych
              </p>
            </div>
            <div className="rounded-xl bg-paper px-3 py-3" data-id="element-187" data-mp="3kee6t3j2gipu">
              <p className="font-display text-xl font-bold text-chem sm:text-2xl" data-id="element-188" data-mp="22zsz3um2v5d">568</p>
              <p className="mt-1 text-[11px] font-semibold uppercase tracking-[0.1em] text-ink/65" data-id="element-189" data-mp="3tfuf95qbmarf">
                Stron gotowych do wydruku
              </p>
            </div>
          </div>

          <div className="mt-5 flex flex-col items-center rounded-xl bg-chem-soft px-4 py-6 text-center" data-id="element-190" data-mp="30r6qv1a9z59n">
            <span className="text-sm font-semibold text-chem-deep" data-id="element-191" data-mp="1g94j0w598ch1">Twój dzisiejszy dostęp</span>
            <span className="mt-1 font-display text-5xl font-bold text-chem sm:text-6xl" data-id="element-192" data-mp="1l1xo5l4mxmtn">
              {PRICE}
            </span>
            <p className="mt-3 text-xs font-medium text-ink/70 sm:text-sm" data-id="element-193" data-mp="17bc25njvwwrj">
              Jednorazowa płatność • Bez abonamentu • Dostęp cyfrowy od razu
            </p>
          </div>
        </div>

        <div className="mt-6" data-id="element-194" data-mp="1zyy4ytlafxdc">
          <CTAButton label="Uzyskaj natychmiastowy dostęp — 17 USD" data-id="element-195" data-mp="23zi422pf9b24" />
          <DailyCountdown data-id="element-196" data-mp="23xntnibs11ca" />
        </div>
      </motion.div>
    </section>;
}